import React, { useState, useEffect } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert, Progress, } from "reactstrap"
import { gql, useMutation } from "@apollo/client"
import "./DriverSmartStatusModal.css"

const UPDATE_AGREEMENT = gql`
  mutation UpdateAgreement($input: UpdateAgreementMutationInput!) {
    updateAgreement(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`

function DriverSmartStatusModal({ isOpen, toggle, agreementId, currentStatus, refetchQuery, handleClose }) {
    const [status, setStatus] = useState(currentStatus)
    const [feedback, setFeedback] = useState({
        loading: false,
        error: null,
        success: null,
    })

    const [updateAgreement] = useMutation(UPDATE_AGREEMENT)
    const handleUpdate = async (newStatus) => {
        setFeedback({ loading: true, error: null, success: null })

        try {
            const { data } = await updateAgreement({
                variables: {
                    input: {
                        agreement: agreementId,
                        participateInDriveSmart: newStatus,
                    },
                },
            })

            if (data?.updateAgreement?.ok) {
                setStatus(newStatus)
                setFeedback({ loading: false, error: null, success: "Updated successfully." })
                refetchQuery && refetchQuery()
                handleClose && handleClose()
            } else {
                const msg =
                    data?.updateAgreement?.errors?.[0]?.messages?.join(", ") ||
                    "An error has occurred. Please contact admin."
                setFeedback({ loading: false, error: msg, success: null })
            }
        } catch (err) {
            setFeedback({
                loading: false,
                error: "An error has occurred. Please contact admin.",
                success: null,
            })
        }
    }

    useEffect(() => {
        if (isOpen) {
            setStatus(currentStatus)
            setFeedback({ loading: false, error: null, success: null })
        }
    }, [isOpen, currentStatus])

    const messageText =
        status === true
            ? "The driver is currently on DriveSmart. Would you like to offboard them?"
            : status === false
                ? "The driver is currently not on DriveSmart. Would you like to onboard them?"
                : "This driver has no DriveSmart status. Please choose to onboard or decline them."
    return (
        <Modal isOpen={isOpen} className="driver-smart-status-modal">
            <ModalHeader>DriverSmart Status</ModalHeader>

            <ModalBody className="text-center">
                {feedback.error && <Alert color="danger">{feedback.error}</Alert>}
                {feedback.success && <Alert color="success">{feedback.success}</Alert>}
                <p className="modal-message">{messageText}</p>
                {feedback.loading && <Progress animated color="info" value={100} />}
            </ModalBody>

            <ModalFooter>
                <Button className="secondary-btn" onClick={toggle} disabled={feedback.loading}>
                    Cancel
                </Button> &nbsp;&nbsp;
                {status === true ?
                    <Button className="danger-btn" disabled={feedback.loading} onClick={() => handleUpdate(false)} >
                        Offboard
                    </Button> : status === false ?
                        <Button className="success-btn" disabled={feedback.loading} onClick={() => handleUpdate(true)}>
                            Onboard
                        </Button> :
                        status === null &&
                        <>
                            <Button className="success-btn" disabled={feedback.loading} onClick={() => handleUpdate(true)}>
                                Onboard
                            </Button>&nbsp;&nbsp;
                            <Button className="danger-btn" disabled={feedback.loading} onClick={() => handleUpdate(false)}>
                                Decline
                            </Button>
                        </>
                }
            </ModalFooter>
        </Modal>
    )
}

export default DriverSmartStatusModal
